import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Row from '../../../core/layout/Row';
import Select from '../../../core/form/Select';
import Button from '../../../core/form/Button';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import LocaleSelect from '../../../core/form/LocaleSelect';

const EmailTemplateListFilter = (props) => (
  <Row>
    <Column size={1.5}>
      <Select
        options={[
          {
            label: 'All',
            value: 'ALL',
          },
          {
            label: 'Student',
            value: 'STUDENT',
          },
          {
            label: 'Kids',
            value: 'KIDS',
          },
          {
            label: 'Parents',
            value: 'PARENTS',
          },
          {
            label: 'Admin',
            value: 'ADMIN',
          },
        ]}
        label="Type"
        value={get(props.values, 'type')}
        onChange={(value) => props.onChange('type', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={2.5}>
      <TextInput
        label="Search by key"
        value={get(props.values, 'key')}
        onChange={(value) => props.onChange('key', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={2.5}>
      <TextInput
        label="Search by subject"
        value={get(props.values, 'subject')}
        onChange={(value) => props.onChange('subject', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={1.5}>
      <LocaleSelect
        label="Missing Email Template for key"
        value={get(props.values, 'localeMissingTemplate')}
        onChange={(value) => props.onChange('localeMissingTemplate', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={2}>
      <div style={{ height: 42 }} />
      <Button label="Search" icon="search" onClick={props.onSearch} />
    </Column>
  </Row>
);

EmailTemplateListFilter.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
};

EmailTemplateListFilter.defaultProps = {
  fetching: false,
};

export default EmailTemplateListFilter;
